import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { http } from '@loyalup/core';
import { Layout, Button, Field, Form, Link, AuthPanel } from '@loyalup/ui';

import { ReactComponent as SendIcon } from 'icons/send.svg';

import s from './ForgotPassword.module.css';

const onSubmit = async (email, setLoading, setError, setSentEmail, t) => {
  if ((email || '').trim() === '') {
    setError(t('введите емейл'));
    return;
  }
  setLoading(true);
  setError(undefined);

  const { ok, error } = await http('POST', '/password/forgot', { email });

  setLoading(false);

  if (ok) {
    setSentEmail(true);
  } else {
    setError(error);
  }
};

const ForgotPassword = () => {
  const [t] = useTranslation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [sentEmail, setSentEmail] = useState();

  return (
    <Layout center title={t('Сброс пароля')}>
      <AuthPanel>
        <div className={s.root}>
          <div className={s.header}>
            <h1>{t('Сброс пароля')}</h1>
          </div>
          {sentEmail && (
            <div className={s.hintContainer}>
              <SendIcon className={s.sentIcon} />
              <p className={s.hint}>
                {t('Мы отправили вам на почту инструкцию по сбросу пароля. Пожалуйста проверьте ваш емейл.')}
              </p>
              <p className={s.hint}>
                {t('Я вспомнил пароль.')}
                &nbsp;
                <Link to="/login">{t('Войти')}</Link>
              </p>
            </div>
          )}
          {!sentEmail && (
            <p className={s.hint}>
              {t('Пожалуйста, введите e-mail, указанный вами при регистрации и мы вышлем ссылку для сброса пароля.')}
            </p>
          )}
          {!sentEmail && (
            <Form onSubmit={() => onSubmit(email, setLoading, setError, setSentEmail, t)}>
              <Field
                label={t('Е-мейл')}
                name="email"
                type="email"
                autoFocus
                value={email}
                error={error}
                disabled={loading}
                onChange={email => setEmail(email)}
              />
              <Button type="submit" fixedWidth={200} loading={loading} center>
                {t('Отправить письмо')}
              </Button>
            </Form>
          )}
          {!sentEmail && (
            <p className={s.hint}>
              {t('Ещё нет аккаунта?')}
              &nbsp;
              <Link to="/register">{t('Зарегистрироваться')}</Link>
            </p>
          )}
        </div>
      </AuthPanel>
    </Layout>
  );
};

export default ForgotPassword;
